import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { useLocation } from "@reach/router"
import PropTypes from "prop-types"
import { useLanguages } from "../hooks/useLanguages"

// Define the Head component
export const Head = ({ description, title, link, meta }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            supportedLanguages
          }
        }
      }
    `
  )

  const [currLanguage] = useLanguages()
  const lang = currLanguage
  const { pathname } = useLocation()

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <>
      <html lang={lang || "en"} />
      <title>{title || defaultTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta
        name="twitter:creator"
        content={site.siteMetadata?.author || ""}
      />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {meta?.map((metaTag, i) => (
        <meta key={i} {...metaTag} />
      ))}
      {link &&
        link?.map((linkTag, i) => (
          <link key={i} rel={linkTag.rel} href={linkTag.href} />
        ))}
    </>
  )
}

Head.defaultProps = {
  title: null,
  meta: [],
  link: [],
  description: ``,
}

Head.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  link: PropTypes.arrayOf(PropTypes.object),
}

export default Head
